import React from 'react';
import cn from 'classnames';
import styles from './index.module.css';

export default ({ children, className, onClick, disabled }) => (
  <button className={cn(styles.Button, className)} onClick={onClick} disabled={disabled}>
    {children}
  </button>
)
